var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.466926 9.92218V30H6.6537V9.92218H0.466926ZM3.61868 0C1.63424 0 0 1.63424 0 3.61868C0 5.60311 1.63424 7.23735 3.61868 7.23735C5.60311 7.23735 7.23735 5.60311 7.23735 3.61868C7.23735 1.63424 5.60311 0 3.61868 0ZM10.5058 9.92218H10.6226V29.7665H16.8093V19.8444C16.8093 17.2763 17.2763 14.7082 20.5447 14.7082C23.8132 14.7082 23.8132 17.7432 23.8132 20.0778V29.8833H30V18.9105C30 13.5409 28.8327 9.33852 22.5292 9.33852C19.4942 9.33852 17.393 10.9728 16.5759 12.607H16.4591V9.92218H10.5058Z",
    fill: "#0077B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.416663d61ce9571f322959ce8419194f.svg";
export { ForwardRef as ReactComponent };